import { GridDotsRegular } from '@fluentui/react-icons';
import type { OnOpenChangeData} from '@fluentui/react-components';
import { Avatar, Button, Label, Popover, PopoverSurface, makeStyles, tokens } from '@fluentui/react-components';
import { useMsal } from '@azure/msal-react';
import React, { useState } from 'react';
import PopoverContent from './PopoverContent/PopoverContent';
import type { IUserInfo } from '../../interfaces';

const useStyles = makeStyles({
  flexContainer: {
    display: 'flex',
    backgroundColor: tokens.colorBrandBackground2,
    position: 'sticky',
    justifyContent: 'space-between',
    flexDirection: 'column',
    top: 0,
    height: 'auto',
    zIndex: 100,
    alignItems: 'stretch',
    '@media (min-width: 48em)': {
      flexDirection: 'row',
      alignItems: 'center',
    }
  },
  header: {
    display: 'inline',
    fontSize: '1em',
    '@media (min-width: 48em)': {
      fontSize: '1.25em'
    }
  },
  avatar: { ":hover": { cursor: 'pointer' } },
  lastItem: {
    paddingTop: '10px',
    paddingBottom: '10px',
    paddingRight: "5px",
    alignSelf: 'end',
    '@media (min-width: 48em)': {
      paddingRight: "20px"
    }
  }
});

export interface IStickyNavBarProps {
  userData?: IUserInfo;
  imageUrl: string;
  onWaffleClick(): void;
}

const StickyNavbar = (props: IStickyNavBarProps) => {
  const { userData, imageUrl, onWaffleClick } = props;
  const styles = useStyles();
  const { instance } = useMsal();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [target, setTarget] = React.useState<HTMLElement | null>(null);


  const onAvatarClicked = (): void => {
    setIsPopoverOpen(!isPopoverOpen);
  };

  const onPopoverOpenChange = (data: OnOpenChangeData): void => {
    setIsPopoverOpen(data.open || false);
  };

  const handleLogout = () => {
    void instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  };

  return (
    <>
      <div className={styles.flexContainer}>
        <div>
          <Button aria-label='MacroView link menu' className={styles.header} appearance='transparent' size="large" icon={<GridDotsRegular />} onClick={() => onWaffleClick()} />
          <Label weight='semibold' className={styles.header}>MacroView Settings</Label>
        </div>
        <div className={styles.lastItem}>
          <Avatar
            className={styles.avatar}
            shape='circular'
            name={userData?.displayName ?? ""}
            image={{ src: imageUrl }}
            onClick={() => onAvatarClicked()}
            ref={setTarget}
          /></div>
      </div>

      <Popover trapFocus positioning={{ position: "below", align: "start", offset: 18, target }} open={isPopoverOpen} onOpenChange={(_, data) => onPopoverOpenChange(data)} >
        <PopoverSurface>
          <PopoverContent onLogout={handleLogout} userData={userData} imageUrl={imageUrl} />
        </PopoverSurface>
      </Popover>
    </>
  );
};

export default StickyNavbar;